import { SVGProps } from 'react';

export const SvgFlex = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        {...props}
    >
        <path
            fill="gray"
            fillRule="evenodd"
            d="M18.686 5.59a.83.83 0 0 0-.769-.515h-4.09a.833.833 0 1 0 0 1.667h2.078l-4.465 4.463-2.82-2.82a.858.858 0 0 0-1.178 0l-5.115 5.117a.833.833 0 0 0 1.18 1.179l4.524-4.528 2.819 2.82a.833.833 0 0 0 1.179 0l5.055-5.054V10a.833.833 0 1 0 1.666 0V5.91a.841.841 0 0 0-.064-.319Z"
            clipRule="evenodd"
        />
    </svg>
);

export const SvgReOpen = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        stroke="#808080"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        className="lucide lucide-refresh-ccw-dot-icon lucide-refresh-ccw-dot"
        viewBox="0 0 24 24"
        {...props}
    >
        <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
        <path d="M3 3v5h5M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
        <path d="M16 16h5v5" />
        <circle cx={12} cy={12} r={1} />
    </svg>
);
